class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    // this.querySelector('#CartDrawer-Form').addEventListener('submit', this.onCheckout.bind(this));

    // setTimeout(() => {
    //   this.querySelector('#CartDrawer-Form').addEventListener('submit', this.onCheckout.bind(this));
    // })
    this.setHeaderCartIconAccessibility();
  }

  connectedCallback() {
    this.querySelector('#CartDrawer-Form').addEventListener('submit', this.onCheckout.bind(this));
  }

  // setupCheckoutStateEnforcer() {
  //   const termsCheckbox = document.getElementById('cart-drawer-terms');
  //   const checkoutButton = document.getElementById('CartDrawer-Checkout'); // Adjust this ID based on your button's ID
    
  //   if (termsCheckbox) {
  //     termsCheckbox.addEventListener('change', this.updateCheckoutState);
  //   }

  //   const enforceButtonState = this.updateCheckoutState.bind(this);

  //   this.subtotalElement = document.querySelector(".totals__subtotal-value"); // Your target element

  //   if (!this.subtotalElement) {
  //       console.error("Subtotal element not found!");
  //       return;
  //   }

  //   // MutationObserver callback function
  //   const observerCallback = (mutationsList) => {
  //     for (const mutation of mutationsList) {
  //       if (mutation.type === "childList") {
  //         console.log("Subtotal content changed to:", this.subtotalElement.innerHTML.trim());
  //         // Add custom logic here, e.g., enforcing checkout button state
  //         enforceButtonState();
     
  //       }
  //     }
  //   };

  //   // Set up the observer
  //   const observer = new MutationObserver(observerCallback);

  //   // Start observing the target element
  //   observer.observe(this.subtotalElement, {
  //       childList: true, // Observe changes to child nodes or text content
  //       subtree: false, // Only observe the direct element, not its descendants
  //   });

  //   console.log("Observer attached to .totals__subtotal-value");
  // }

  // connectedCallback() {
  //   this.setupCheckoutStateEnforcer();
  // }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  updateCheckoutState() {
    // Get references to the checkbox and checkout button
    const termsCheckbox = document.getElementById('cart-drawer-terms');
    const checkoutButton = document.getElementById('CartDrawer-Checkout'); // Adjust this ID based on your button's ID
    
    //Disable the checkout button initially 

    if (termsCheckbox.checked) {    
      checkoutButton.disabled = false;
    } else {
      checkoutButton.disabled = true;
    }
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);

      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    // this.setupCheckoutStateEnforcer();
    this.querySelector('#CartDrawer-Form').addEventListener('submit', this.onCheckout.bind(this));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
      
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  onCheckout(e) {
    // debugger;
    const termsCheckbox = document.querySelector("#cart-drawer-terms");
    const checkoutButton = document.querySelector('#CartDrawer-Checkout');
    if (termsCheckbox.checked) {
      checkoutButton.name="checkout";
    } else {    
      e.preventDefault();
      alert("You must read and accept the terms and conditions of sales to check out");
    }
    
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);





